import { useState } from "react";
import { useT } from "../i18n";
import { FolderPicker } from "./FolderPicker";
import type { FolderNode } from "./folder-tree";

// Pick a destination folder/device (or root) to move N items to — the keyboard-accessible
// counterpart to drag-and-drop.
export function MoveDialog({
  count,
  folders,
  onClose,
  onMove,
}: {
  count: number;
  folders: FolderNode[];
  onClose: () => void;
  onMove: (folderId: string) => void;
}) {
  const t = useT();
  const [dest, setDest] = useState<string | null>(null);
  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/60" onClick={onClose}>
      <div className="w-[420px] rounded-md border border-border bg-panel shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="border-b border-border px-4 py-3 font-semibold">{t("Move to…")}</div>
        <div className="flex flex-col gap-3 px-4 py-4 text-sm">
          <span className="text-xs text-muted">{count} {t("item(s)")}</span>
          <FolderPicker value={dest} folders={folders} onChange={setDest} ariaLabel={t("Move to…")} className="text-xs" />
          <div className="flex justify-end gap-2">
            <button onClick={onClose} className="rounded border border-border px-3 py-1.5 text-xs hover:border-accent">{t("Cancel")}</button>
            <button onClick={() => onMove(dest ?? "")} className="rounded bg-accent px-3 py-1.5 text-xs font-medium text-white hover:bg-accent2">{t("Move")}</button>
          </div>
        </div>
      </div>
    </div>
  );
}
